module.exports = __webpack_public_path__ + "media/images/icon__plus@2x-bbc2bd3d5b8f71443bb90b37228468ef.png";